var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartPathOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99827 0.000127813H4.38622L1.16867 9.33333H0L3.99795 0.000127813H3.99827ZM6.72123 1.76692H7.48147L7.54756 3.27945H6.65507L6.72116 1.76692H6.72123ZM6.56475 4.03626H7.62872L7.6877 6.26065H6.46882L6.56468 4.03626H6.56475ZM5.05781 0H6.76053L6.71248 1.26124H7.4906L7.44231 0H9.12025L12.063 9.33321H7.90767L7.77158 7.31515H6.42425L6.30629 9.33321H2.13894L5.0583 0H5.05781ZM9.79195 0H10.2598L14 9.33321H13.0335L9.79177 0H9.79195Z",
    fill: "#636F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartPathOnly);
export default __webpack_public_path__ + "static/media/Cart-pathOnly.4b943dc2e583f7294acd10bd76082a62.svg";
export { ForwardRef as ReactComponent };